import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function UrgencyBar() {
  const [timeLeft, setTimeLeft] = useState({
    minutes: 14,
    seconds: 59
  });
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds === 0) {
          if (prev.minutes === 0) return prev;
          return {
            minutes: prev.minutes - 1,
            seconds: 59
          };
        }
        return {
          ...prev,
          seconds: prev.seconds - 1
        };
      });
    }, 1000);
    const handleScroll = () => {
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      clearInterval(timer);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-0 left-0 right-0 bg-brand-dark text-white py-3 px-4 z-50 shadow-2xl border-t border-brand-gold/30 animate-in slide-in-from-bottom duration-500" data-id="element-269">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row justify-between items-center gap-3" data-id="element-270">
        <div className="flex items-center text-sm sm:text-base font-medium" data-id="element-271">
          <div className="bg-red-600 text-white px-2 py-0.5 rounded text-xs font-bold mr-3 animate-pulse" data-id="element-272">
            EXPIRA PRONTO
          </div>
          <span className="hidden sm:inline" data-id="element-273">Oferta de Lanzamiento:</span>
          <span className="ml-2 text-brand-gold font-bold" data-id="element-274">$6.36 USD</span>
          <span className="mx-2 text-gray-500 line-through text-xs" data-id="element-275">$148</span>
        </div>

        <div className="flex items-center gap-4 w-full sm:w-auto" data-id="element-276">
          <div className="flex items-center text-brand-gold font-mono font-bold bg-black/30 px-3 py-1 rounded" data-id="element-277">
            <Clock className="h-4 w-4 mr-2" data-id="element-278" />
            {String(timeLeft.minutes).padStart(2, '0')}:
            {String(timeLeft.seconds).padStart(2, '0')}
          </div>
          <a href="https://www.betterbysteps.com/cart/44216026333277:1" target="_blank" rel="noopener noreferrer" className="bg-brand-gold hover:bg-yellow-500 text-brand-dark font-bold px-4 py-1.5 rounded text-sm transition-colors flex-1 sm:flex-none text-center" onClick={() => {
          if (typeof (window as any).fbq === 'function') {
            ;
            (window as any).fbq('track', 'AddToCart');
          }
        }} data-id="element-279">
            RECLAMAR OFERTA
          </a>
        </div>
      </div>
    </div>;
}